module.exports = __webpack_public_path__ + "assets/6c4b6e52dbb51c9934ef47554d8544a3.png";